import DesignedButton from '@design-system/components/atoms/Button/_Button'
import * as React from 'react'

type Props = React.ComponentProps<typeof DesignedButton> &
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
  ButtonT

type ButtonT =
  | {
      minWidth: 80 | 100 | 120 | 144 | 160
      width?: never
    }
  | {
      minWidth?: never
      width: 80 | 100 | 120 | 144 | 160
    }
  | {
      minWidth?: never
      width: '100%'
    }

/**
 *
 * @deprecated
 */
const _Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, width, minWidth, style, ...props }, ref) => {
    return (
      <DesignedButton
        {...(style && { style })}
        {...(width && { width })}
        {...(minWidth && { minWidth })}
        ref={ref}
        {...props}
      >
        {children}
      </DesignedButton>
    )
  },
)

_Button.displayName = '_Button'

export default _Button
